(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MoreController', MoreController);

    MoreController.$inject = ['$window', 'Auth', '$state', 'UserProfileQuery', 'ServantCustom', 'CompanyInfoQuery', 'ActivityTypeInfoCustom', 'CompanySubscriptionStatusCustom', '$timeout', '$localStorage'];

    function MoreController($window, Auth, $state, UserProfileQuery, ServantCustom, CompanyInfoQuery, ActivityTypeInfoCustom, CompanySubscriptionStatusCustom, $timeout, $localStorage) {
        var vm = this;

        vm.currentPersonInfo = {};
        vm.logout = logout;
        vm.goToCurrentServant = goToCurrentServant;
        vm.hasSubscription = true;
        vm.isNativeApp = null;

        loadPage();

        function loadPage() {
            getCurrentPersonInfo();
            loadActivityTypeInfo();
            hasActiveSubscription();
        }

        function logout() {
            Auth.logout();
            vm.currentUser = {};
            $state.go('home');

        }

        function getCurrentPersonInfo() {
            UserProfileQuery.getCurrentPersonInfo().query(function (up) {
                vm.currentPersonInfo = up;
            })
        }

        function goToCurrentServant() {
            ServantCustom.findServantByCurrentUser().query().$promise.then(function (result) {

                $state.transitionTo('supplierPanel-v2.companyServants.edit', {id: result.id});

            });

        }

        function loadActivityTypeInfo() {
            ActivityTypeInfoCustom.getActivityTypeInfoByCurrentCompany().query(function (result) {
                vm.activityTypeInfo = result;
                checkActivityType();
            })
        }

        function checkActivityType() {
            if (vm.activityTypeInfo) {
                if (vm.activityTypeInfo.servantType && vm.activityTypeInfo.servantType == 'RESOURCE') {
                    vm.isWorkSpace = true;
                    vm.servantTranslateFile = "supplierPanel.sideMenu.workSpaceInfo-v2";
                    return;
                }


            }
            vm.servantTranslateFile = "supplierPanel.sideMenu.servantInfo-v2";
            vm.isWorkSpace = false;

        }

        function hasActiveSubscription() {
            CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(hasSubscriptionSuccess, hasSubscriptionError);

            function hasSubscriptionSuccess(result) {
                if (result.status == 'DONE')
                    vm.hasSubscription = true;
                else
                    vm.hasSubscription = false;
            }

            function hasSubscriptionError() {
                vm.hasSubscription = false;
            }
            $timeout(function(){
                vm.isNativeApp = $localStorage.isNativeApp;
            },10)

        }
    }
})();
